<section class="verify">
  <div class="pre-head slide__right">
    <mat-icon svgIcon="logo-rebillia" class="custom-mat-icon ico-isologo-login"></mat-icon>
  </div>
  <div class="head slide__right">
    <mat-icon svgIcon="ico-verify" class="custom-mat-icon ico-size ico-lg"></mat-icon>
    <h1 class="typo display-3 semi-condensed fw300 label-title">Verify Your Email</h1>    
  </div>
  <div class="body slide__right">
    <p>To unlock access to Rebillia Platform, please click the link in the email we sent you to <strong>{{userEmail}}</strong>. The verification link will expire after 24hs.</p>
    <div class="nav-links">
      <a [routerLink]="['/login/signin']" routerLinkActive="router-link-active"  class="custom-mat-link link-back">
        <mat-icon svgIcon="ico-back" class="custom-mat-icon ico-size ico-3xs"></mat-icon>Go back to login
      </a>
    </div>
  </div>
  <div class="footer slide__right">
    <p class="typo caption condensed fw400 label-copyright">© 2001-2019. All Rights Reserved. Rebillia Platform® is a
      registered trademark of Rebillia LLC. Cookie Preferences, Privacy, and Terms.</p>
  </div>
</section>